var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,255.99385,255.99385",
    width: "64px",
    height: "64px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: "none",
    strokeLinecap: "none",
    strokeLinejoin: "none",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54,20c0,-5.523 -4.477,-10 -10,-10h-12h-12c-5.523,0 -10,4.477 -10,10v24.008c0,5.523 4.477,10 10,10h12h12c5.523,0 10,-4.477 10,-10z",
    fill: "#3482c2",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 61,
    rx: 20,
    ry: 3,
    fill: "#000000",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.01,12h-0.01c-2.24,1.69 -3.75,4.29 -3.97,7.25c-0.02,0.24 -0.03,0.5 -0.03,0.75v12c2.761,0 5,-2.239 5,-5v-7c0,-0.108 0.003,-0.221 0.017,-0.38c0.102,-1.375 0.778,-2.65 1.862,-3.525c0.048,-0.033 0.095,-0.068 0.142,-0.103c0.86,-0.649 1.89,-0.992 2.979,-0.992h5c2.761,0 5,-2.239 5,-5h-10c-2.25,0 -4.32,0.74 -5.99,2z",
    fill: "#ffffff",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,44v-22c-2.761,0 -5,2.238 -5,5v17c0,2.757 -2.243,5 -5,5h-5c-2.761,0 -5,2.238 -5,5h10c5.523,0 10,-4.477 10,-10z",
    fill: "#000000",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,23.5v-3.5c0,-0.153 0.005,-0.312 0.018,-0.459c0.135,-1.809 1.003,-3.46 2.396,-4.594l0.204,-0.152",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,26h4c0.552,0 1,0.448 1,1v18c0,0.552 -0.448,1 -1,1h-4c-0.552,0 -1,-0.448 -1,-1v-18c0,-0.552 0.448,-1 1,-1z",
    fill: "#ffffff",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.982,24h-0.034c-1.79,0 -2.948,-1.334 -2.948,-3.001c0,-1.703 1.194,-2.999 3.017,-2.999c1.825,0 2.95,1.296 2.983,2.999c0,1.665 -1.158,3.001 -3.018,3.001z",
    fill: "#ffffff",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,46c-0.552,0 -1,-0.448 -1,-1v-9.615c0,-2.564 -1.429,-4.314 -3.724,-4.314c-1.751,0 -2.699,1.181 -3.158,2.322c-0.168,0.407 -0.118,1.537 -0.118,2.107v9.5c0,0.552 -0.448,1 -1,1h-4c-0.552,0 -1,-0.448 -1,-1v-18c0,-0.552 0.448,-1 1,-1h4c0.552,0 1,0.448 1,1v2c0.841,-1.302 2.325,-3.006 5.694,-3.006c4.174,0 7.304,2.797 7.304,8.659l0.002,10.347c0,0.552 -0.448,1 -1,1z",
    fill: "#ffffff",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedsvg);
export default __webpack_public_path__ + "static/media/Linkedsvg.7624d184cb42736d1352f9278c076d18.svg";
export { ForwardRef as ReactComponent };